import React from 'react'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  showText?: boolean
  className?: string
  onClick?: () => void
}

const sizeClasses = {
  sm: 'h-6',
  md: 'h-8',
  lg: 'h-12'
}

const textSizeClasses = {
  sm: 'text-sm',
  md: 'text-lg',
  lg: 'text-2xl'
}

export const Logo: React.FC<LogoProps> = ({
  size = 'md',
  showText = true,
  className = '',
  onClick
}) => {
  const Component = onClick ? 'button' : 'div'

  return (
    <Component
      onClick={onClick}
      className={`flex items-center space-x-3 ${onClick ? 'hover:opacity-80 transition-opacity cursor-pointer' : ''} ${className}`}
    >
      <img
        src="/munchiesLogo-black.png"
        alt="Neighbourhood Munchies"
        className={`${sizeClasses[size]} w-auto `}
        loading="eager"
        decoding="async"
      />
      {showText && (
        <div className="hidden sm:block">
          <h1 className={`${textSizeClasses[size]} font-semibold text-grey`}>
            Admin Panel
          </h1>
          <p className="text-xs text-neutral-500 -mt-1">
            Neighbourhood Munchies
          </p>
        </div>
      )}
    </Component>
  )
}

// Simplified logo for mobile/compact spaces
export const LogoMark: React.FC<{ size?: 'sm' | 'md' | 'lg'; className?: string }> = ({
  size = 'md',
  className = ''
}) => (
  <img
    src="/munchiesLogo-black.png"
    alt="Neighbourhood Munchies"
    className={`${sizeClasses[size]} w-auto ${className}`}
    loading="eager"
    decoding="async"
  />
)
